import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Flex, Image, Text } from '@chakra-ui/react'

import { Button } from 'components/ui/Buttons/Button'

export const EmptyCart = (): JSX.Element => {
  const { t } = useTranslation('common')

  return (
    <Flex
      direction="column"
      justifyContent="space-between"
      alignItems="center"
      height="100%"
      maxWidth="380px"
      marginX="auto"
    >
      <Flex direction="column" justifyContent="center" alignItems="center" height="100%">
        <Image width="180px" src="/icons/cart-preview.svg" />
        <Text fontSize="lg" color="black" fontWeight={500} marginTop="30px">
          {t('emptyCartHeading')}
        </Text>
        <Text color="gray.a500" fontSize="sm" fontWeight={300} marginY="15px">
          {t('emptyCartCopy')}
        </Text>
      </Flex>

      <Box width="100%" marginBottom="46px" marginTop={{ lg: '50px' }}>
        <Button href="/browse">{t('browseProducts')}</Button>
      </Box>
    </Flex>
  )
}
